import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectVersion } from 'src/app/constants/project-version-constans';
import { ClientModel } from 'src/app/models/archive/client.model';
import { DevolutionDetailPrintModel } from 'src/app/models/print/rental/devolution-detail-print.model';
import { DevolutionPrintModel } from 'src/app/models/print/rental/devolution-print.model';
import { FormatsEnums } from './../../../../enum/formats-enums';
import { FormatDetailModel } from './../../../../models/formats/format-detail.model';
import { FormatModel } from './../../../../models/formats/format.model';
import { FormatDetailService } from './../../../../services/formats/format-detail.service';
import { FormatService } from './../../../../services/formats/format.service';
import { EnterpriseService } from './../../../../services/management/enterprise.service';
import { PrintPageSizeService } from 'src/app/services/global-services/print-page-size.service';

@Component({
  selector: 'app-print-devolution',
  templateUrl: './print-devolution.component.html',
  styleUrls: ['./print-devolution.component.scss'],
  standalone: false
})
export class PrintDevolutionComponent implements OnChanges {

  @Input() companyId: number | null = 0;
  @Input() editFormat: boolean = false;
  @Input() exportFormat: boolean = false;
  @Input() devolutionPrintModel: DevolutionPrintModel = new DevolutionPrintModel();
  @Input() focusText: boolean = false;
  @Input() formatDetail: FormatDetailModel = new FormatDetailModel();
  @Input() reloadPrint: boolean = false;
  @Input() swIncludeStore: boolean = false;
  @Output() emitFormatDetail = new EventEmitter<FormatDetailModel>();
  @Output() finishLoadingPrint = new EventEmitter<boolean>();

  bottomPreview: number = 0;
  clientContract: ClientModel = new ClientModel();
  columns: { field: string; header: string; }[] = [];
  idMap: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: any; } } = {
    'articleCode': { id: 'articulo', type: 'text', showTotal: false, printFormat: null },
    'articleName': { id: 'articulo-nombre', type: 'text', showTotal: false, printFormat: null },
    'storeCode': { id: 'bodega', type: 'text', showTotal: false, printFormat: null },
    'cleaningQuantityDevolution': { id: 'cantidad-limpieza-devolucion', type: 'decimal', showTotal: false, printFormat: null },
    'cleaningValueDevolution': { id: 'valor-limpieza-devolucion', type: 'decimal', showTotal: false, printFormat: null },
    'repairQuantityDevolution': { id: 'cantidad-rep-devolucion', type: 'decimal', showTotal: false, printFormat: null },
    'repairValueDevolution': { id: 'valor-rep-devolucion', type: 'decimal', showTotal: false, printFormat: null },
    'quantity': { id: 'cantidad', type: 'decimal', showTotal: true, printFormat: null },
    'replacementQuantity': { id: 'cantidad-faltante', type: 'decimal', showTotal: true, printFormat: null },
    'totalQuantity': { id: 'cantidad-total', type: 'decimal', showTotal: false, printFormat: null },
    'replacementValue': { id: 'valor-unitario-faltante', type: 'decimal', showTotal: false, printFormat: null },
    'totalReplacementValue': { id: 'valor-total-faltante', type: 'decimal', showTotal: true, printFormat: null },
    'totalRepairValue': { id: 'valor-total-repara', type: 'decimal', showTotal: true, printFormat: null },
    'totalM2': { id: 'total-m2', type: 'decimal', showTotal: true, printFormat: null },
    'totalWeight': { id: 'peso-total', type: 'decimal', showTotal: true, printFormat: null },
    'rentalUnit': { id: 'unidad-medida', type: 'text', showTotal: false, printFormat: null }
  };
  columnsRepairs: { field: string; header: string; }[] = [];
  idMapRepairs: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: any; } } = {
    'repairArticleCode': { id: 'articulo-reparacion', type: 'text', showTotal: false, printFormat: null },
    'repairArticleName': { id: 'articulo-nombre-reparacion', type: 'text', showTotal: false, printFormat: null },
    'repairQuantity': { id: 'cantidad-reparacion', type: 'decimal', showTotal: false, printFormat: null },
    'repairUnitValue': { id: 'valor-unitario-reparacion', type: 'decimal', showTotal: false, printFormat: null },
    'repairTotalValue': { id: 'valor-total-reparacion', type: 'decimal', showTotal: true, printFormat: null }
  };
  dateNow: Date = new Date();
  element: any;
  elementStyle: any;
  formatModel: FormatModel = new FormatModel();
  id = '';
  isShift = false;
  elementsBody: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementsLabel: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  leftPreview: number = 0;
  listFormatDetailUpdates: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  logoEnterprise: SafeUrl = "";
  mouseDown: boolean = false;
  newFormatDetail: FormatDetailModel = new FormatDetailModel();
  rightPreview: number = 0;
  shiftX: number = 0;
  shiftY: number = 0;
  speed = 2;
  thArticleCode: string = "";
  thArticleName: string = "";
  thStoreCode: string = "";
  thQuantity: string = "";
  thRepairArticleCode: string = "";
  thRepairArticleName: string = "";
  thRepairQuantity: string = "";
  thRepairUnitValue: string = "";
  thRepairTotalValue: string = "";
  thReplacementQuantity: string = "";
  thReplacementValue: string = "";
  thTotalQuantity: string = "";
  thTotalRepairValue: string = "";
  thTotalReplacementValue: string = "";
  thTotalM2: string = "";
  thTotalWeight: string = "";
  thRentalUnit: string = "";
  topPreview: number = 0;
  version: string = ProjectVersion.projectVersion;
  private keydownListener!: (e: KeyboardEvent) => void;
  private mouseupListener!: () => void;
  private mousemoveListener!: (e: MouseEvent) => void;
  private keyupListener!: (e: KeyboardEvent) => void;

  constructor(private cdr: ChangeDetectorRef,
    private enterpriseService: EnterpriseService,
    private formatDetailService: FormatDetailService,
    private formatService: FormatService,
    private sanitizer: DomSanitizer,
    private printPageSizeService: PrintPageSizeService) { }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const reloadPrint = changes["reloadPrint"];
    const exportFormat = changes["exportFormat"];
    const formatDetail = changes["formatDetail"];
    const devolutionPrintModel = changes["devolutionPrintModel"];

    if (reloadPrint && !reloadPrint.firstChange) {
      if (devolutionPrintModel && !devolutionPrintModel.firstChange) {
        if (this.devolutionPrintModel.enterpriseLogo != null) {
          this.listFormatDetailUpdates = new Array<FormatDetailModel>();
          await this.getLogo(this.devolutionPrintModel.enterpriseLogo);
        } else {
          this.getLogoDefault();
        }
        await this.getFormatByCompanyAndCode();
      }
    }

    if (exportFormat && !exportFormat.firstChange) {
      this.updateRangeFormatDetail();
    }
    if (formatDetail && !formatDetail.firstChange) {
      this.changeFormatDetail();
    }
  }

  ngOnDestroy() {
    this.printPageSizeService.removePageSizeStyle();

    // Remover event listeners globales
    if (this.keydownListener) document.removeEventListener('keydown', this.keydownListener);
    if (this.mouseupListener) document.removeEventListener('mouseup', this.mouseupListener, true);
    if (this.mousemoveListener) document.removeEventListener('mousemove', this.mousemoveListener, true);
    if (this.keyupListener) document.removeEventListener('keyup', this.keyupListener);
  }

  ngAfterViewInit() {
    if (this.editFormat) {
      this.keydownListener = (e: KeyboardEvent) => {
        const target = e.target as HTMLElement;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.isContentEditable)
        ) {
          return;
        }
        // 2. Si no hay ningún elemento seleccionado para mover, no bloquear
        if (!this.element) {
          return;
        }

        // Deshabilita desplazamiento del scroll con la tecla espacio y flechas
        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
          this.blockScrollArrows(e);
        }

        if (e.which == 16) this.isShift = true;
        //Mover element con flechas
        if (!this.isShift) {
          switch (e.key) {
            case 'ArrowLeft': { this.moveLeft(); break; }
            case 'ArrowRight': { this.moveRight(); break; }
            case 'ArrowUp': { this.moveUp(); break; }
            case 'ArrowDown': { this.moveDown(); break; }
          }
        }

        //Modificar element tamaño de objeto
        if (this.isShift) {
          switch (e.which) {
            case 37: { this.decreaseWidth(); break; }
            case 38: { this.decreaseHeight(); break; }
            case 39: { this.increaseWidth(); break; }
            case 40: { this.increaseHeight(); break; }
          }
        }
      };

      this.mouseupListener = () => {
        this.onMouseUp();
      };

      this.mousemoveListener = (e: MouseEvent) => {
        this.onMouseMove(e);
      };

      this.keyupListener = (e: KeyboardEvent) => {
        if (e.which == 16) this.isShift = false;
      };

      // Registrar los listeners en el document
      document.addEventListener('keydown', this.keydownListener);
      document.addEventListener('mouseup', this.mouseupListener, true);
      document.addEventListener('mousemove', this.mousemoveListener, true);
      document.addEventListener('keyup', this.keyupListener);
    }
  }

  private adjustElementSize(property: 'height' | 'width', delta: number) {
    if (this.focusText) {
      return;
    }
    const currentValue = this.elementStyle.getPropertyValue(property);
    const numericValue = parseFloat(currentValue.replace('px', ''));
    const newValue = numericValue + delta;
    this.element.style[property] = `${newValue}px`;
    this.onClick();
  }

  private async applyColumnStyles(devolutionPrintModel: DevolutionPrintModel) {
    for (const column of this.columns.map(x => x.field)) {
      const element = this.elementsBody.find(x => x.description === column);
      if (!element) {
        continue;
      }
      this.element = document.getElementById(`${element.name}-${devolutionPrintModel.devolutionId}`);
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        await this.changeAlignment(element.alignment);
      }
    }
  }

  setGroupingStyles(element: FormatDetailModel, classEdit: any) {
    classEdit.forEach((el: HTMLElement) => {
      el.style.fontSize = `${element.fontSize}px`;
      el.style.width = `${element.width}%`;
      el.style.textAlign = element.alignment;
      el.style.fontWeight = element.bold;
    });
  }

  private applyElementStyles(element: FormatDetailModel) {
    if (!element.visible) {
      this.element!.setAttribute('hidden', '');
      return;
    }

    const style = this.element!.style;
    style.fontSize = `${element.fontSize}px`;
    this.changeAlignment(element.alignment);
    this.changeBold(element.bold);
    this.changeBorder(element.border);

    if (element.name.includes('foot-')) {
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    } else {
      style.backgroundColor = 'transparent';
      style.position = 'absolute';
      style.left = `${element.left}%`;
      style.top = `${element.top}%`;
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    }
  }

  private applyFormatDetails(elements: FormatDetailModel[], devolutionPrintModel: DevolutionPrintModel) {
    for (const element of elements) {
      if (element.band === 'body') {
        continue;
      }
      setTimeout(async () => {
        this.element = document.getElementById(`${element.name}-${devolutionPrintModel.devolutionId}`);
        if (this.element) {
          this.applyElementStyles(element);
        }
      }, 200);

      setTimeout(() => {
        //Cargo los encabezados del detalle:
        this.columns.map(x => x.field).forEach(column => {
          const element = this.elementsBody.find(x => x.description === column);
          this.element = document.getElementById(`${element!.name}-${this.devolutionPrintModel.devolutionId}`);
          if (this.element) {
            this.element.style.fontSize = `${element!.fontSize}px`;
            this.element.style.width = `${element!.width}%`;
            this.changeAlignment(element!.alignment);
          }
        });

        //Cargo los encabezados de las reparaciones:
        this.devolutionPrintModel.devolutionDetails.forEach(detail => {
          if (detail.devolutionRepairs && detail.devolutionRepairs.length != 0) {
            const element = this.formatModel.formatDetails.find(x => x.name === 'articulo-reparacion');
            this.element = document.getElementById(`articulo-reparacion-${detail.devolutionDetailId}`);
            if (!element!.visible) {
              this.element.setAttribute('hidden', '');
            } else {
              this.element.style.fontSize = `${element!.fontSize}px`;
              this.changeAlignment(element!.alignment);
              this.changeBold(element!.bold);
            }
            this.columnsRepairs.map(x => x.field).forEach(column => {
              const element = this.elementsBody.find(x => x.description === column);
              this.element = document.getElementById(`${element!.name}-${detail.devolutionDetailId}`);
              if (this.element) {
                this.element.style.fontSize = `${element!.fontSize}px`;
                this.element.style.width = `${element!.width}%`;
                this.changeAlignment(element!.alignment);
              }
            });
          }
        });

        this.elementsBody.filter(x => x.type === 'p').forEach(element => {
          if (element.name.includes("reparacion")) {
            //Cargo los detalles de las reparaciones:
            this.devolutionPrintModel.devolutionDetails.forEach(detail => {
              if (detail.devolutionRepairs && detail.devolutionRepairs.length != 0) {
                detail.devolutionRepairs.forEach(repair => {
                  const id = element.name.includes("footer") ? detail.devolutionDetailId : repair.repairId;
                  this.element = document.getElementById(`${element.name}-${id}`);
                  if (this.element) {
                    this.element.style.fontSize = `${element.fontSize}px`;
                    this.changeAlignment(element.alignment);
                    this.changeBold(element.bold);
                  }
                });
              }
            });
          } else {
            //Cargo los detalles:
            this.devolutionPrintModel.devolutionDetails.forEach(detail => {
              const id = element.name.includes("footer") ? detail.devolutionId : detail.devolutionDetailId;
              this.element = document.getElementById(`${element.name}-${id}`);
              if (this.element) {
                this.element.style.fontSize = `${element.fontSize}px`;
                this.changeAlignment(element.alignment);
                this.changeBold(element.bold);
              }
            });
          }
        });

        this.dateNow = new Date();
      }, 200);
    }
  }

  private applyFormatStyles(element: HTMLElement) {
    element.style.fontSize = `${this.formatDetail.fontSize}px`;
    this.changeAlignment(this.formatDetail.alignment);
    this.changeBold(this.formatDetail.bold);
    this.changeBorder(this.formatDetail.border);

    if (!this.formatDetail.name.includes('foot-')) {
      element.style.position = 'absolute';
      element.style.left = `${this.formatDetail.left}%`;
      element.style.top = `${this.formatDetail.top}%`;
    }

    element.style.height = `${this.formatDetail.height}px`;
    element.style.width = `${this.formatDetail.width}px`;
  }

  private applyHeaderFooterHeights(devolutionId: number, formatModel: FormatModel) {
    setTimeout(async () => {
      const head = document.getElementById(`head-${devolutionId}`);
      head!.style.height = `${formatModel.head}px`;
      const foot = document.getElementById(`foot-${devolutionId}`);
      foot!.style.height = `${formatModel.foot}px`;
    }, 200);
  }

  private applyParagraphStyles(devolutionPrintModel: DevolutionPrintModel) {
    this.elementsBody.filter(x => x.type === 'p').forEach(element => {
      devolutionPrintModel.devolutionDetails!.forEach(detail => {
        const id = element.name.includes("footer") ? detail.devolutionId : detail.devolutionDetailId;
        this.element = document.getElementById(`${element.name}-${id}`);
        if (this.element) {
          this.element.style.fontSize = `${element.fontSize}px`;
          this.changeAlignment(element.alignment);
          this.changeBold(element.bold);
        }
      });
    });
  }

  blockScrollArrows(e: any) {
    if (!this.focusText) {
      e.preventDefault();
    }
  }

  private buildDisplayedColumns() {
    this.columns = [];
    this.columnsRepairs = [];
    this.elementsBody.filter(x => x.type === 'label' && !x.name.includes('reparacion')).forEach(element => {
      if (element.description == 'storeCode' && this.swIncludeStore == false) {
        return;
      }
      this.columns.push({ field: element.description!, header: element.text! });
      this.idMap[element.description!].printFormat = element.printFormat ?? null;
    });
    this.elementsBody.filter(x => x.type === 'label' && x.name.includes('reparacion')).forEach(element => {
      this.columnsRepairs.push({ field: element.description!, header: element.text! });;
      this.idMapRepairs[element.description!].printFormat = element.printFormat ?? null;
    });
  }

  changeAlignment(alignment: string) {
    this.element.style.textAlign = alignment;
  }

  changeBold(bold: string) {
    this.element.style.fontWeight = bold;
  }

  changeBorder(border: string) {
    switch (border) {
      case 'noborder': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        break;
      }
      case 'border': {
        this.element.style.border = '1px solid rgb(0, 0, 0)';
        break;
      }
      case 'underline': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        this.element.style.borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }
  }

  changeFormatDetail() {
    const formatDetailId = this.formatDetail.formatDetailId;
    if (formatDetailId == 0) return;
    const isBody = this.formatDetail.band === 'body';
    const isLabel = this.formatDetail.type === 'label';

    if (isBody) {
      const element = this.elementsBody.find(x => x.formatDetailId === formatDetailId);
      if (!element) {
        return;
      }

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;
      element.printFormat = this.formatDetail.printFormat;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;

        if (!this.formatDetail.visible) {
          if (this.formatDetail.name.includes('reparacion')) {
            this.columnsRepairs = this.columnsRepairs.filter(x => x.field !== element.description);
          } else {
            this.columns = this.columns.filter(x => x.field !== element.description);
          }
        } else {
          if (this.formatDetail.name.includes('reparacion')) {
            this.devolutionPrintModel.devolutionDetails.forEach(detail => {
              if (detail.devolutionRepairs && detail.devolutionRepairs.length != 0) {
                this.updateElementWidth(this.formatDetail.name, detail.devolutionDetailId);
                this.updateElementStyle(this.formatDetail.name, detail.devolutionDetailId);
              }
            });
          } else {
            this.updateElementWidth(this.formatDetail.name, this.devolutionPrintModel.devolutionId!);
            this.updateElementStyle(this.formatDetail.name, this.devolutionPrintModel.devolutionId!);
          }
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        if (this.formatDetail.name.includes('reparacion')) {
          this.devolutionPrintModel.devolutionDetails.forEach(detail => {
            if (detail.devolutionRepairs && detail.devolutionRepairs.length != 0) {
              if (this.formatDetail.name === 'articulo-reparacion') {
                const element = this.formatModel.formatDetails.find(x => x.name === 'articulo-reparacion');
                this.element = document.getElementById(`articulo-reparacion-${detail.devolutionDetailId}`);
                if (!element!.visible) {
                  this.element.setAttribute('hidden', '');
                } else {
                  this.element.style.fontSize = `${element!.fontSize}px`;
                  this.changeAlignment(this.formatDetail.alignment);
                  this.changeBold(this.formatDetail.bold);
                }
              }
              detail.devolutionRepairs.forEach(repair => {
                const id = this.formatDetail.name.includes("footer") ? detail.devolutionDetailId : repair.repairId;
                this.element = document.getElementById(`${this.formatDetail.name}-${id}`);
                if (this.element) {
                  this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
                  this.changeAlignment(this.formatDetail.alignment);
                  this.changeBold(this.formatDetail.bold);
                }
              });
            }
          });
        } else {
          this.devolutionPrintModel.devolutionDetails!.forEach(detail => {
            if (detail.devolutionDetailId) {
              const id = this.formatDetail.name.includes("footer") ? detail.devolutionId : detail.devolutionDetailId;
              this.element = document.getElementById(`${this.formatDetail.name}-${id}`);
              if (this.element) {
                this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
                this.changeAlignment(this.formatDetail.alignment);
                this.changeBold(this.formatDetail.bold);
              }
            }
          });
        }
      }

      this.elementsBody = this.elementsBody.filter(x => x.formatDetailId !== formatDetailId);
      this.elementsBody.push(element);
      const fieldName = element.description;
      if (fieldName && this.idMap[fieldName]) {
        this.idMap[fieldName].printFormat = element.printFormat;
      } else if (fieldName && this.idMapRepairs[fieldName]) {
        this.idMapRepairs[fieldName].printFormat = element.printFormat;
      }
    } else {
      this.updateElementStyle(this.formatDetail.name, this.devolutionPrintModel.devolutionId!);

      if (!this.formatDetail.visible) {
        this.element.setAttribute('hidden', '');
      } else {
        this.applyFormatStyles(this.element);
        this.updateLabelText(formatDetailId, this.formatDetail.text!);
        this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== formatDetailId);
        this.listFormatDetailUpdates.push(this.formatDetail);
      }
    }
  }

  async chargeFormat(formatModel: FormatModel): Promise<boolean> {
    return new Promise((resolved) => {
      this.formatModel = formatModel;
      this.printPageSizeService.setPageSizeStyle(formatModel.paperSizeId);
      this.applyHeaderFooterHeights(this.devolutionPrintModel.devolutionId!, formatModel);
      this.extractFormatDetails(formatModel);
      this.buildDisplayedColumns();
      this.applyFormatDetails(formatModel.formatDetails, this.devolutionPrintModel);
      setTimeout(async () => {
        await this.applyColumnStyles(this.devolutionPrintModel);
        this.applyParagraphStyles(this.devolutionPrintModel);
        resolved(true);
      }, 200);
    });
  }

  clickTable(event: any) {
    if (!this.editFormat) {
      return;
    }

    const element = document.getElementById(event.target.id);
    if (!element) {
      return;
    }

    const elementStyle = window.getComputedStyle(element);
    const name = event.target.id.substring(0, event.target.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    const bodyElement = this.elementsBody.find(x => x.name === name);

    if (!formatDetail || !bodyElement) {
      return;
    }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.type = formatDetail.type;
    this.newFormatDetail.visible = bodyElement.visible;
    this.newFormatDetail.text = bodyElement.text;
    this.newFormatDetail.orderTable = bodyElement.orderTable;
    this.newFormatDetail.printFormat = bodyElement.printFormat;

    if (formatDetail.type === 'label') {
      const rawWidth = element.style.width;
      const width = parseFloat(rawWidth.replace('%', '')) || 0;
      this.newFormatDetail.width = parseFloat(width.toFixed(4));
    } else {
      this.newFormatDetail.width = 0;
    }
    const fontSize = parseInt(elementStyle.getPropertyValue('font-size').replace('px', ''));
    this.newFormatDetail.fontSize = isNaN(fontSize) ? 0 : fontSize;
    const fontWeight = elementStyle.getPropertyValue('font-weight');
    this.newFormatDetail.bold = fontWeight === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = elementStyle.getPropertyValue('text-align');

    this.emitFormatDetail.emit(this.newFormatDetail);
  }

  decreaseHeight() {
    this.adjustElementSize('height', -this.speed);
  }

  decreaseWidth() {
    this.adjustElementSize('width', -this.speed);
  }

  onColumnReorder(columns: { field: string; header: string; }[]) {
    columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  onColumnReorderRepairs(columns: { field: string; header: string; }[]) {
    columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  private extractFormatDetails(formatModel: FormatModel) {
    this.elementsLabel = formatModel.formatDetails.filter(x => x.type === 'label');
    this.elementsBody = formatModel.formatDetails
      .filter(x => x.band === 'body' && x.visible)
      .sort((a, b) => a.orderTable - b.orderTable);
  }

  private getBorderStyle(): string {
    if (this.elementStyle.getPropertyValue('border')) {
      if (this.elementStyle.getPropertyValue('border') === '0px none rgb(0, 0, 0)') {
        return 'noborder';
      } else {
        return 'border';
      }
    } else {
      return 'underline';
    }
  }

  async getFormatByCompanyAndCode() {
    const promises: any = [];
    if (this.companyId != null && this.companyId != 0) {
      this.devolutionPrintModel.devolutionDetails!.forEach((detail, index) => {
        index += 1;
        detail.index = index;
      });
      try {
        const response = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId, FormatsEnums.devolution));
        Promise.all(promises).then(async () => {
          await this.chargeFormat(response);
          this.cdr.detectChanges();
          requestAnimationFrame(() => {
            this.finishLoadingPrint.emit(true);
          });
        });
      } catch (error) {
        console.error('Error al obtener el formato por empresa y código.', error);
      }
    }
  }

  async getLogo(enterpriseLogo: string) {
    let blob: Blob | null = null;
    try {
      blob = await firstValueFrom(this.enterpriseService.getEnterpriseLogoAsync(enterpriseLogo));
      if (blob) {
        this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      }
    } catch (error) {
      console.error('Error al obtener el logo de la empresa.', error);
    }
  }

  async getLogoDefault() {
    const logoPath = 'assets/images/icons/logo-empty.png';
    this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(logoPath);
  }

  getRepairTotalValue(devolutionDetailPrintModel: DevolutionDetailPrintModel): number {
    return devolutionDetailPrintModel.devolutionRepairs.map(t => t.repairTotalValue).reduce((acc, value) => acc + value, 0);
  }

  private getStylePx(property: string): number {
    return parseFloat(this.elementStyle.getPropertyValue(property).replace('px', '')) || 0;
  }

  private getStylePxValue(property: string): number {
    const value = this.elementStyle.getPropertyValue(property);
    return parseFloat(value.replace('px', '')) || 0;
  }

  increaseHeight() {
    this.adjustElementSize('height', this.speed);
  }

  increaseWidth() {
    this.adjustElementSize('width', this.speed);
  }

  moveDown() {
    this.moveElement('top', this.speed, this.bottomPreview, true);
  }

  private moveElement(direction: 'top' | 'left', delta: number, previewLimit: number, isVertical: boolean) {
    if (this.focusText || !this.elementStyle) {
      return;
    }

    const currentValue = this.elementStyle.getPropertyValue(direction);
    let position = parseFloat(currentValue.replace('px', ''));
    position += delta;
    const sizeProp = isVertical ? 'height' : 'width';
    const size = parseFloat(this.elementStyle.getPropertyValue(sizeProp).replace('px', ''));
    if (position < 0) {
      position = 0;
    }
    if (position + size > previewLimit) {
      position = previewLimit - size;
    }
    const percentage = ((position / previewLimit) * 100).toFixed(4);
    this.element.style[direction] = `${percentage}%`;

    this.onClick();
  }

  moveLeft() {
    this.moveElement('left', -this.speed, this.rightPreview, false);
  }

  moveRight() {
    this.moveElement('left', this.speed, this.rightPreview, false);
  }

  moveUp() {
    this.moveElement('top', -this.speed, this.bottomPreview, true);
  }

  onClick() {
    if (!this.editFormat) {
      return;
    }

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) {
      return;
    }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.text = formatDetail.text;
    this.newFormatDetail.visible = true;
    this.newFormatDetail.printFormat = formatDetail.printFormat;

    this.newFormatDetail.fontSize = this.getStylePxValue('font-size');
    this.newFormatDetail.bold = this.elementStyle.getPropertyValue('font-weight') === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = this.elementStyle.getPropertyValue('text-align');
    this.newFormatDetail.border = this.getBorderStyle();

    if (!name.includes('foot-')) {
      this.newFormatDetail.left = parseFloat(((this.getStylePxValue('left') / this.rightPreview) * 100).toFixed(4));
      this.newFormatDetail.top = parseFloat(((this.getStylePxValue('top') / this.bottomPreview) * 100).toFixed(4));
    }

    this.newFormatDetail.width = parseFloat(this.getStylePxValue('width').toFixed(4));
    this.newFormatDetail.height = parseFloat(this.getStylePxValue('height').toFixed(4));

    this.emitFormatDetail.emit(this.newFormatDetail);
    this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== this.newFormatDetail.formatDetailId);
    this.listFormatDetailUpdates.push(this.newFormatDetail);
  }

  onDragStart() {
    return false;
  }

  onMouseDown(event: any) {
    if (!this.editFormat) {
      return;
    }

    if (this.element) {
      this.element.style.backgroundColor = 'transparent';
    }

    this.mouseDown = true;
    this.id = event.target.id;
    this.element = document.getElementById(this.id);
    if (!this.element) {
      return;
    }

    this.elementStyle = window.getComputedStyle(this.element);
    this.element.style.backgroundColor = '#0d6efd6e';

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) {
      return;
    }

    const relativeElement = document.getElementById(`${formatDetail.band}-${this.devolutionPrintModel.devolutionId}`);
    if (!relativeElement) {
      return;
    }

    const relativeStyle = window.getComputedStyle(relativeElement);

    this.leftPreview = Math.round(relativeElement.offsetLeft - relativeElement.scrollLeft);
    this.topPreview = Math.round(relativeElement.offsetTop - relativeElement.scrollTop);
    this.rightPreview = parseInt(relativeStyle.width.replace('px', ''));
    this.bottomPreview = parseInt(relativeStyle.height.replace('px', ''));

    this.element.style.cursor = 'move';
    const leftPX = event.pageX - this.leftPreview;
    const topPX = event.pageY - this.topPreview;
    this.shiftX = leftPX - this.getStylePx('left');
    this.shiftY = topPX - this.getStylePx('top');

    this.onClick();
  }

  onMouseMove(event: any) {
    if (!this.mouseDown || this.id.includes('foot-')) return;

    this.element.style.position = 'absolute';
    const leftPx = Math.max(0, event.pageX - this.leftPreview - this.shiftX);
    const widthPx = this.getStylePx('width');
    const finalLeft = Math.min(leftPx, this.rightPreview - widthPx);
    const topPx = Math.max(0, event.pageY - this.topPreview - this.shiftY);
    const heightPx = this.getStylePx('height');
    const finalTop = Math.min(topPx, this.bottomPreview - heightPx);

    this.updateElementPosition(finalLeft, finalTop);
    this.onClick();
  }

  onMouseUp() {
    this.mouseDown = false;
  }

  private updateElementWidth(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }
    this.element.style.width = `${this.formatDetail.width}%`;
  }

  private updateLabelText(formatId: number, text: string) {
    const labelElement = this.elementsLabel.find(x => x.formatDetailId === formatId);
    if (labelElement) {
      labelElement.text = text;
    }
  }

  private updateElementPosition(leftPx: number, topPx: number) {
    const leftPercentage = ((leftPx / this.rightPreview) * 100).toFixed(4);
    const topPercentage = ((topPx / this.bottomPreview) * 100).toFixed(4);
    this.element.style.left = `${leftPercentage}%`;
    this.element.style.top = `${topPercentage}%`;
  }

  private updateElementStyle(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }
    this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
  }

  async updateRangeFormatDetail() {
    this.elementsBody.forEach(element => {
      this.listFormatDetailUpdates.push(element);
    });
    const response = await firstValueFrom(this.formatDetailService.updateRangeFormatDetail(this.listFormatDetailUpdates));
    this.chargeFormat(response);
  }

}
